import { useDeployStatus } from '../services/deployStatus';

export function DeployOverlay() {
  const isDeploying = useDeployStatus();
  if (!isDeploying) return null;
  return (
    <div
      role="alert"
      aria-live="assertive"
      className="fixed inset-0 z-[999999] flex items-center justify-center bg-white"
    >
      <div className="flex flex-col items-center gap-6 p-6 text-center">
        <div className="h-12 w-12 animate-spin rounded-full border-4 border-gray-200 border-t-emerald-500" />
        <p className="text-lg text-gray-900">Deploy is in progress…</p>
      </div>
    </div>
  );
}
